/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AllowToRecoverPinMutationVariables = {
    userId: string;
};
export type AllowToRecoverPinMutationResponse = {
    readonly allowToRecoverPin: {
        readonly user: {
            readonly id: string;
            readonly inPinRecovery: boolean;
        };
        readonly supportCopy: string;
    } | null;
};
export type AllowToRecoverPinMutation = {
    readonly response: AllowToRecoverPinMutationResponse;
    readonly variables: AllowToRecoverPinMutationVariables;
};



/*
mutation AllowToRecoverPinMutation(
  $userId: ID!
) {
  allowToRecoverPin(userId: $userId) {
    user {
      id
      inPinRecovery
    }
    supportCopy
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "AllowToRecoverPin",
    "kind": "LinkedField",
    "name": "allowToRecoverPin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inPinRecovery",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "supportCopy",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AllowToRecoverPinMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AllowToRecoverPinMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0baac3f63297bf6d9a437c7601fa0c64",
    "id": null,
    "metadata": {},
    "name": "AllowToRecoverPinMutation",
    "operationKind": "mutation",
    "text": "mutation AllowToRecoverPinMutation(\n  $userId: ID!\n) {\n  allowToRecoverPin(userId: $userId) {\n    user {\n      id\n      inPinRecovery\n    }\n    supportCopy\n  }\n}\n"
  }
};
})();
(node as any).hash = '1b95b684e585d0f4f188ede77ba7da25';
export default node;
